/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { Box, Modal, Typography, Divider, Grid } from '@mui/material';
import PropTypes from 'prop-types';
import { ReactComponent as CloseModalIcon } from '../../../../assets/images/close-modal.svg';
import { CustomDatePicker } from '../../../../components/CustomDatePicker';
import { CustomButton } from '../../../../components/CustomButton';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  minHeight: 308,
  bgcolor: 'background.paper',
  boxShadow: '0px 12px 32px rgba(42, 70, 94, 0.03)',
  borderRadius: '12px',
  outline: 'none'
};

export const ReportModal = ({ showModal, setShowModal, download }) => {
  const [dates, setDate] = useState({
    startDate: '',
    endDate: ''
  });
  const [error, setError] = useState('')

  const handleDates = (value, name) => setDate(prevState => ({ ...prevState, [name]: value }));

  useEffect(() => {
    if (dates.startDate && dates.endDate && dates.startDate > dates.endDate) setError('Дата начала периода не может быть больше даты конца');
    else setError('');
  }, [dates])

  return (
    <Modal open={showModal} onClose={() => setShowModal(false)} data-testid="Modal">
      <Box sx={style}>
        <Box display="flex" justifyContent="space-between" alignItems="center" p="24px">
          <Typography variant="h5" fontWeight={500}>
            Выгрузить отчет
          </Typography>
          <CloseModalIcon cursor={'pointer'} onClick={() => setShowModal(false)} data-testid="CloseModal"/>
        </Box>
        <Divider />
        <Box p="24px">
          <Typography width={400}>Выберите период за который вы хотите сформировать отчет по движению Промокодов</Typography>
        </Box>
        <Box display="flex" justifyContent="space-between" flexWrap="nowrap" margin="0 24px">
          <Box>
            <CustomDatePicker
              placeholder="C"
              sx={{ width: '214px' }}
              variant="outlined"
              size="small"
              onChange={(e) => {
                handleDates(e || '', 'startDate');
              }}
              value={dates.startDate}
              weekend
              previousDate
              offLastDate={false}
            />
          </Box>
          <Box>
            <CustomDatePicker
              placeholder="По"
              sx={{ width: '214px' }}
              variant="outlined"
              size="small"
              weekend
              previousDate
              offLastDate={false}
              dateStart={dates.startDate}
              onChange={(e) => {
                handleDates(e || '', 'endDate');
              }}
              value={dates.endDate}
            />
          </Box>
        </Box>
        <Box color="error.main" fontSize="1rem" textAlign="center">{ error }</Box>
        <Box margin="24px" display="flex" justifyContent="right">
          <CustomButton
            type="submit"
            size="large"
            variant="contained"
            disabled={!!error}
            onClick={() => {
              download(dates.startDate, dates.endDate);
              setShowModal(false);
            }}
          >
            Скачать
          </CustomButton>
        </Box>
      </Box>
    </Modal>
  );
};

ReportModal.propTypes = {
  showModal: PropTypes.bool,
  setShowModal: PropTypes.func,
  companyBonuses: PropTypes.array,
  permission: PropTypes.bool,
  download: PropTypes.func
};
